module.exports = __webpack_public_path__ + "img/tarjeta_py.72cafca7.png";